module.exports = __webpack_public_path__ + "img/326.859e3474.jpg";